var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.203,
    height: 56,
    viewBox: "0 0 73.203 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_6569358_and_applications_code_coding_computer_icon",
    "data-name": "6569358_and_applications_code_coding_computer_icon",
    transform: "translate(-0.95 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25893",
    "data-name": "Group 25893",
    transform: "translate(0.95 48.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26433",
    "data-name": "Path 26433",
    d: "M71.68,35.174H3.507a2.905,2.905,0,0,1-2.191-1.217,2.212,2.212,0,0,1,0-2.435l4.87-7.3A2.557,2.557,0,0,1,8.376,23H66.811A2.34,2.34,0,0,1,69,24.461l4.87,7.3a2.842,2.842,0,0,1,0,2.435A3.626,3.626,0,0,1,71.68,35.174Z",
    transform: "translate(-0.95 -23)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_26434",
    "data-name": "Path 26434",
    d: "M60,5H6.435A2.3,2.3,0,0,0,4,7.435V41.522a2.3,2.3,0,0,0,2.435,2.435H60a2.3,2.3,0,0,0,2.435-2.435V7.435A2.3,2.3,0,0,0,60,5ZM22.748,30.078a2.354,2.354,0,0,1,0,3.409,2.354,2.354,0,0,1-3.409,0l-7.3-7.3a2.354,2.354,0,0,1,0-3.409l7.3-7.3a2.41,2.41,0,1,1,3.409,3.409l-5.6,5.6Zm17.53-14.365L30.539,35.191a2.34,2.34,0,0,1-2.191,1.461c-.487,0-.73,0-.974-.243a2.149,2.149,0,0,1-.974-3.165l9.739-19.478a2.149,2.149,0,0,1,3.165-.974A2.342,2.342,0,0,1,40.278,15.713ZM54.4,26.183l-7.3,7.3a2.354,2.354,0,0,1-3.409,0,2.354,2.354,0,0,1,0-3.409l5.6-5.6-5.6-5.6A2.41,2.41,0,1,1,47.1,15.47l7.3,7.3A2.354,2.354,0,0,1,54.4,26.183Z",
    transform: "translate(4.376 0)",
    fill: "#666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployment);
export default __webpack_public_path__ + "static/media/deployment.ed0b69749e34bef87e058d96ce797508.svg";
export { ForwardRef as ReactComponent };